var oldGuests = [
    {'name':'QasarYounis','title':'Y Combinator','img':'http://static-image.xfz.cn/explore/images/xfz2017/qasar.png'},
    {'name':'Ashish Sharma','title':'Paytm','img':'http://static-image.xfz.cn/explore/images/xfz2017/ashish.png'},
    {'name':'Vikas Banga','title':'Snapdeal','img':'http://static-image.xfz.cn/explore/images/xfz2017/vikas.png'},
    {'name':'Ophir Gore','title':'以色列驻华使馆','img':'http://static-image.xfz.cn/explore/images/xfz2017/ophir.png'},
    {'name':'Dovi Ollech','title':'E.MERGR Fund','img':'http://static-image.xfz.cn/explore/images/xfz2017/dovi.png'},
    {'name':'Justin Kan','title':'Y Combinator','img':'http://static-image.xfz.cn/explore/images/xfz2017/justin.png'},
    {'name':'张颖','title':'经纬中国','img':'http://static-image.xfz.cn/explore/images/xfz2017/zhangying.png'},
    {'name':'朱啸虎','title':'金沙江创投','img':'http://static-image.xfz.cn/explore/images/xfz2017/zhuxiaohu.png'},
    {'name':'戴威','title':'ofo共享单车','img':'http://static-image.xfz.cn/explore/images/xfz2017/daiwei.png'},
    {'name':'吴海燕','title':'华创资本','img':'http://static-image.xfz.cn/explore/images/xfz2017/wuhaiyan2.png'},
    {'name':'宿华','title':'快手','img':'http://static-image.xfz.cn/explore/images/xfz2017/suhua.png'},
    {'name':'肖文杰','title':'分期乐','img':'http://static-image.xfz.cn/explore/images/xfz2017/xiaowenjie.png'},
]
export default oldGuests



// WEBPACK FOOTER //
// ./src/assets/js/guest_data.js